module.exports = __webpack_public_path__ + "static/media/2 pokemon lapras galaxy color tattoo anime gamer ink cardgame .1280x1707.e97129da.webp";